<template>
    <div class="post-header">
        <h1 class="post-title">{{ post.title }}</h1>
        <p class="post-date-author">
            <span v-if="post.author.url.indexOf('linusmarco.com') > -1">
                <router-link to="/about" class="evergreen">{{ post.author.name }}</router-link>
            </span>
            <span v-else>
                <a v-on:click.stop v-bind:href="post.author.url" class="evergreen">{{ post.author.name }}</a>
            </span>
            |
            <span class="post-date">{{ formatDate(post.publishDate, 'long') }}</span>
        </p>
    </div>
</template>

<script>
import { formatDate } from '../../services/helpers';

export default {
    name: 'post-header',
    props: ['post'],
    methods: {
        formatDate: formatDate
    }
};
</script>

<style scoped>
.post-title {
    font-size: 2.5rem;
    margin: 2rem 0 0 0;
}

.post-date-author {
    font-size: 1rem;
    margin: 1rem 0 1.5rem 0;
}
</style>
